app.RecommendationVariationList = app.AbstractCollection.extend({
  model: app.RecommendationVariation,

  url() {
    return '/api/v2/recommendation-variations';
  },
});
